import { max } from "lodash";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import type { Dayjs } from "dayjs";

export function nextDate(startDate: Dayjs, products: { daysShift: number }[]) {
  const lastDate = products.length > 0 ? max(products.map((p) => startDate.add(p.daysShift, "days"))) : null;
  const newDate = lastDate ? dayjs(lastDate, ISO_DATE_FORMAT).add(1, "days") : startDate;
  return newDate.format(ISO_DATE_FORMAT);
}
